import { urlForImage } from 'lib/sanity.image'
import Image from 'next/image'
import { PortableText } from '@portabletext/react'

const TextComponents: any = {
  block: {
    normal: ({ children }) => (
      <p className="max-w-[600px] pb-16 text-12 leading-120 text-darkGray last-of-type:pb-0 md:pb-32 md:text-14">
        {children}
      </p>
    ),
  },
}

export const TwoColImageText = ({
  image,
  imagePosition,
  title,
  eyebrow,
  text,
}) => {
  const url = urlForImage(image).width(600).dpr(3).url()
  const aspect = image.aspect
  return (
    <div className="grid grid-cols-1 gap-10 p-20 md:grid-cols-2 md:gap-[80px]">
      <div className={`${imagePosition === 'right' ? 'order-2' : ''}`}>
        <div
          className="leading-0 relative overflow-hidden rounded-12"
          style={{ aspectRatio: aspect }}
        >
          <Image src={url} fill style={{ objectFit: 'cover' }} alt="" />
        </div>
      </div>
      <div className={`pt-20 ${imagePosition === 'right' ? 'order-1' : ''}`}>
        <div className="pb-12 text-10 uppercase leading-110 text-gray md:pb-14">
          {eyebrow}
        </div>
        <h2 className="pb-20 text-18 font-bold leading-100 text-darkGray md:pb-40 md:text-20">
          {title}
        </h2>
        <PortableText value={text} components={TextComponents} />
      </div>
    </div>
  )
}
